import React from 'react'
import { Domain } from 'Types/Domain'
import { useTranslation } from 'react-i18next'
import * as codeFunctions from '../../../domainsManagement/components/GetTagModal/components/Instructions/utils'
import { CopyTextButton } from '@clickcease/cc-client-components-lib'
import {
  CodeBlock,
  GetTagInstructionsContainer,
  GtmScrollInstruction,
  Row,
} from './Methods/Instructions.styled'
import {
  CodeBlockWrapper,
  GoogleTagManagerManualText,
  InstructionsTitle,
} from './Methods/elements/GoogleTagManagerManual/GoogleTagManagerManual.styled'
import { BulletLine } from './Methods/elements/BulletLine'

type GoogleTagManagerWrapperProps = {
  tagUrl: string
  domain: Domain | undefined
}

export const NoGtmGoogleTagManager = ({ tagUrl, domain }: GoogleTagManagerWrapperProps) => {
  const { t } = useTranslation('domainManagement')
  const domainHashCode = domain?.tagHashCode || ''
  const code = codeFunctions.generateCodeScript(tagUrl, domainHashCode)
  const noScriptUrl = codeFunctions.generateGtmNoScriptUrl(tagUrl, domainHashCode)

  return (
    <Row>
      <GtmScrollInstruction css={{ flex: 1 }}>
        <GetTagInstructionsContainer>
          <GoogleTagManagerManualText>
            {t('get_tag_modal.gtm_manual_steps.title')}
          </GoogleTagManagerManualText>
          <BulletLine>1. {t('get_tag_modal.gtm_manual_steps.step_1')}</BulletLine>
          <BulletLine>2. {t('get_tag_modal.gtm_manual_steps.step_2')}</BulletLine>
          <BulletLine>3. {t('get_tag_modal.gtm_manual_steps.step_3')}</BulletLine>
          <BulletLine>4. {t('get_tag_modal.gtm_manual_steps.step_4')}</BulletLine>
          <BulletLine>5. {t('get_tag_modal.gtm_manual_steps.step_5')}</BulletLine>
          <BulletLine>6. {t('get_tag_modal.gtm_manual_steps.step_6')}</BulletLine>

          {/* Code blocks */}
          <CodeBlockWrapper>
            <InstructionsTitle>
              {t('get_tag_modal.gtm_manual_steps.invocation_tag')}
            </InstructionsTitle>
            <CodeBlock>{code}</CodeBlock>
            <CopyTextButton value={code} buttonText={t('get_tag_modal.copy-code')} />
          </CodeBlockWrapper>
          <CodeBlockWrapper>
            <InstructionsTitle>
              {t('get_tag_modal.gtm_manual_steps.no_script_tag')}
            </InstructionsTitle>
            <CodeBlock>{noScriptUrl}</CodeBlock>
            <CopyTextButton value={noScriptUrl} buttonText={t('get_tag_modal.copy-code')} />
          </CodeBlockWrapper>
        </GetTagInstructionsContainer>
      </GtmScrollInstruction>
    </Row>
  )
}
